import React from'react';

var SVG=function SVG(){

return(
React.createElement("svg",{viewBox:"0 0 32 32",role:"img","aria-labelledby":"title  desc"},
React.createElement("title",null,"Popout"),
React.createElement("desc",null,"Popout"),
React.createElement("g",{"data-name":"popout"},
React.createElement("rect",{className:"popout",height:"22",width:"22",x:"1",y:"8"}),
React.createElement("polyline",{className:"popout",points:"23 23 31 23 31 1 9 1 9 9"}))));




};

export default SVG;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2ljb25zL3BvcG91dC5qcyJdLCJuYW1lcyI6WyJSZWFjdCIsIlNWRyJdLCJtYXBwaW5ncyI6IkFBQUEsTUFBT0EsTUFBUCxLQUFrQixPQUFsQjs7QUFFQSxHQUFNQyxLQUFNLFFBQU5BLElBQU0sRUFBTTs7QUFFaEI7QUFDRSwyQkFBSyxRQUFRLFdBQWIsQ0FBMEIsS0FBSyxLQUEvQixDQUFxQyxrQkFBZ0IsYUFBckQ7QUFDRSwwQ0FERjtBQUVFLHlDQUZGO0FBR0UseUJBQUcsWUFBVSxRQUFiO0FBQ0UsNEJBQU0sVUFBVSxRQUFoQixDQUF5QixPQUFPLElBQWhDLENBQXFDLE1BQU0sSUFBM0MsQ0FBZ0QsRUFBRSxHQUFsRCxDQUFzRCxFQUFFLEdBQXhELEVBREY7QUFFRSxnQ0FBVSxVQUFVLFFBQXBCLENBQTZCLE9BQU8sMEJBQXBDLEVBRkYsQ0FIRixDQURGOzs7OztBQVdELENBYkQ7O0FBZUEsY0FBZUEsSUFBZiIsImZpbGUiOiJwb3BvdXQuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IFNWRyA9ICgpID0+IHtcblxuICByZXR1cm4oXG4gICAgPHN2ZyB2aWV3Qm94PVwiMCAwIDMyIDMyXCIgIHJvbGU9XCJpbWdcIiBhcmlhLWxhYmVsbGVkYnk9XCJ0aXRsZSAgZGVzY1wiPlxuICAgICAgPHRpdGxlPlBvcG91dDwvdGl0bGU+XG4gICAgICA8ZGVzYz5Qb3BvdXQ8L2Rlc2M+XG4gICAgICA8ZyBkYXRhLW5hbWU9XCJwb3BvdXRcIj5cbiAgICAgICAgPHJlY3QgY2xhc3NOYW1lPVwicG9wb3V0XCIgaGVpZ2h0PVwiMjJcIiB3aWR0aD1cIjIyXCIgeD1cIjFcIiB5PVwiOFwiLz5cbiAgICAgICAgPHBvbHlsaW5lIGNsYXNzTmFtZT1cInBvcG91dFwiIHBvaW50cz1cIjIzIDIzIDMxIDIzIDMxIDEgOSAxIDkgOVwiLz5cbiAgICAgIDwvZz5cbiAgICA8L3N2Zz5cbiAgKVxuXG59XG5cbmV4cG9ydCBkZWZhdWx0IFNWRztcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/popout.js
// module id = 2171
// module chunks = 0